import { find, get } from "lodash";
import { useEffect, useLayoutEffect, useRef } from "react";
import { useQuery } from "shared/hooks/useApi";
import { PROCESS_SESSION_REPLAY } from "utils/api/graphql/queries/processes";
import {
  SESSION_REPLAY_MASK_CLASS,
  startSessionReplay,
  stopSessionReplay,
  trackSessionReplayStep,
} from "utils/helpers/sessionReplay";

const useSessionReplay = ({ processId, projectId, currentStatus }) => {
  const { data } = useQuery(PROCESS_SESSION_REPLAY, {
    variables: { where: { id: processId } },
    skip: !processId,
    onError: () => {},
  });
  const process = get(data, "process");
  const enabled = get(process, "additionalInfo.sessionReplay") === true;
  const statusId = get(currentStatus, "id");
  const status = find(get(process, "processStatuses"), { id: statusId });
  const maskData = enabled && get(status, "config.maskData") === true;
  const currentStatusRef = useRef(currentStatus);
  currentStatusRef.current = currentStatus;

  useLayoutEffect(() => {
    if (!maskData) return;
    document.body.classList.add(SESSION_REPLAY_MASK_CLASS);
    return () => document.body.classList.remove(SESSION_REPLAY_MASK_CLASS);
  }, [maskData]);

  useEffect(() => {
    if (!enabled) return;
    startSessionReplay();
    return stopSessionReplay;
  }, [enabled]);

  useEffect(() => {
    if (!enabled || !projectId || !statusId) return;
    trackSessionReplayStep({
      project_id: projectId,
      process_id: processId,
      step_id: statusId,
      step_name: get(currentStatusRef.current, "name"),
      step_template: get(currentStatusRef.current, "template"),
      inputs_masked: maskData,
    });
  }, [enabled, projectId, processId, statusId, maskData]);
};

export default useSessionReplay;
